export enum GiftCardAmountEnum {
  OTHER = 0,
  TEN = 10,
  TWENTY = 20,
  FIFTY = 50,
  ONEHUNDRED = 100,
  FIVEHUNDRED = 500
}
